import React from "react"
import { graphql } from "gatsby"
import Card from "../components/Card"
import GeneralLayout from "../layouts/GeneralLayout"
import "../styles.css"

const Projects = props => {
  let data = props.data.allContentfulProjects.edges
  return (
    <GeneralLayout>
      <div className="aboutWrap">
        <div className="row">
          <div className="col-md-12">
            <h1 style={{ textAlign: "center" }}>Projects</h1>
          </div>
        </div>
        <div className="row" style={{ margin: "1em" }}>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">React</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">Nodejs</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">React Native</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">ElectronJS</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">React</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">Nodejs</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">React Native</button>
          </div>
          <div className="tagSt">
            <button className="btn btn-dark btn-sm">ElectronJS</button>
          </div>
        </div>
        <hr />
        <div className="container">
          <div className="row">
            {data.map(node => (
              <div className="col-md-4" style={{marginBottom:'15px'}}>
                <Card
                  name={node.node.name}
                  link={node.node.link}
                  tools={node.node.tools}
                  img={node.node.image.fluid.src}
                  description={node.node.description}
                  buttonText="View Demo"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </GeneralLayout>
  )
}

export default Projects

export const query = graphql`
  query {
    allContentfulProjects {
      edges {
        node {
          name
          description
          tools
          link
          image {
            fluid {
              src
            }
          }
        }
      }
    }
  }
`
